module.exports = __webpack_public_path__ + "static/media/checked.ec8a7374.svg";